import { render } from "./AccountSidebar.vue?vue&type=template&id=45a6694a&scoped=true"
import script from "./AccountSidebar.vue?vue&type=script&lang=js"
export * from "./AccountSidebar.vue?vue&type=script&lang=js"

import "./AccountSidebar.vue?vue&type=style&index=0&id=45a6694a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a6694a"]])

export default __exports__